import React from "react";
import { useColorMode } from "native-base";

export const WithColorMode = Component => (props) => {
    const componentProps = {
        ...props,
        colorMode: useColorMode().colorMode,
    }

    return <Component { ...componentProps } />
}